import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { appWithTranslation } from 'next-i18next';

import '@spa/offer/app.scss';
import { theme } from '@spa/offer/theme';
import SEO from '@spa/offer/components/SEO';
import { makeStore } from '@spa/offer/store';
import nextI18NextConfig from '../next-i18next.config';
import { MediaProvider } from '@spa/shared/contexts/media';
import { buildDatadogData } from '@spa/shared/utils/datadog';
import ScriptWrapper from '@spa/offer/components/ScriptWrapper';

const ModalDisplayer = dynamic(() => import('@spa/offer/components/Modals/modal-displayer'), { ssr: false });

const MyApp = ({ Component, pageProps, pageProps: { seoProps, isMobile = false, isCrawler, eulerianProps } }) => {
  const datadogData = buildDatadogData(pageProps.initialState, 'offer');

  return (
    <ThemeProvider theme={theme}>
      <Provider store={makeStore(pageProps)}>
        <MediaProvider isMobileView={isMobile}>
          {seoProps && <SEO seoProps={seoProps} />}
          <Component {...pageProps} />
          <ModalDisplayer />
        </MediaProvider>
        {!isCrawler ? <ScriptWrapper eulerianProps={eulerianProps} datadogData={datadogData} /> : null}
      </Provider>
    </ThemeProvider>
  );
};

MyApp.propTypes = {
  Component: PropTypes.elementType,
  pageProps: PropTypes.object,
  isMobileView: PropTypes.bool
};

export default appWithTranslation(MyApp, nextI18NextConfig);
